import styled from 'styled-components';
import { BUTTON_SIZES, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { useCampaignSendSize } from 'modules/campaigns/lib/hooks';

import { useModalContext, ModalType, useCampaignContext } from '../../context';
import { useSendCampaign } from './useSendCampaign';
import { getHasDeliverySettings, getRecipientsDisplayText } from '../../utils';

export const SEND_CAMPAIGN_MODAL_TEST_ID = 'send-campaign-modal';
export const SEND_CAMPAIGN_BUTTON_TEST_ID = 'send-campaign-button';
export const SEND_CAMPAIGN_BANNER_TEST_ID = 'send-campaign-delivery-settings-warning-banner';

const CampaignName = styled.span`
  font-weight: bold;
`;

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

/**
 * Schedules a campaign to go out ASAP
 */
export const SendCampaignModal = () => {
  const { campaign, estimatedSendSizeData, expectedSendSizeData } = useCampaignContext();
  const { sendSize, isEstimated } = useCampaignSendSize({
    estimatedSendSizeData,
    expectedSendSizeData,
  });

  const { closeModal } = useModalContext();
  const { isLoading, sendCampaign } = useSendCampaign();

  const handleConfirm = () => {
    sendCampaign();
  };

  const hasDeliverySettings = getHasDeliverySettings(campaign);

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.SendCampaign)}
      id="send-now-modal"
      data-test={SEND_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Send campaign now?</ModalHeader>
      <StyledModalBody>
        <div>
          This will send to{' '}
          <CampaignName>{getRecipientsDisplayText(sendSize, isEstimated)}</CampaignName>
          &nbsp;immediately.
        </div>
        {hasDeliverySettings && (
          <WarningBanner data-test={SEND_CAMPAIGN_BANNER_TEST_ID} Icon={false}>
            This campaign has delivery settings applied that will impact when your recipients will
            receive this campaign. To send this to all recipients immediately, update your delivery
            settings.
          </WarningBanner>
        )}
      </StyledModalBody>
      <ModalFooter>
        <Button
          data-test={SEND_CAMPAIGN_BUTTON_TEST_ID}
          onClick={handleConfirm}
          isDisabled={isLoading}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Send campaign
        </Button>
      </ModalFooter>
    </Modal>
  );
};
